import React from 'react';

function Footer() {
  return (
    <footer className="App-footer">
      <center><p><u><font face="arial" color="black"><mark>YOU WALK WITH A LIGHT STEP YOU ARE NOT YOUR THOUGHTS YOU ARE STRONG!! YESS ITS RIPPED TO BE IN A BODY SHOOTING A BALL OF WHITE LIGHT AT YOU RIGHT NOW JAI MA JAYA GURU DEV SITA RAM!!!!!!</mark></font></u></p></center>
    </footer>
  );
}

export default Footer;
